module.exports = __webpack_public_path__ + "static/botanic-702ccabe453774ec6de7614917672376.png";